import { PropsWithChildren } from 'react';
import {
    createOrGetIntersectionContext,
    useIntersectionTarget,
    UseIntersectionTargetCallback,
    UseIntersectionTargetOptions,
} from 'rwl-ui';

export const PARENT_PAGE_INTERSECTION_OBSERVER_NAME =
    'parent-page-intersection-observer';

// Create the context and Provider once, and export them for use in other components
const { Provider } = createOrGetIntersectionContext(
    PARENT_PAGE_INTERSECTION_OBSERVER_NAME
);

export const ParentPageIntersectionProvider = ({
    children,
}: PropsWithChildren<unknown>): JSX.Element => {
    // When the root element is NULL it will use the page/iframe viewport as the intersection boundary.
    // See IntersectionObserver API for more details
    return <Provider value={{ rootEl: null }}>{children}</Provider>;
};

export const useParentPageIntersection = (
    onIntersection: UseIntersectionTargetCallback,
    onIntersectionEnd: UseIntersectionTargetCallback,
    options: UseIntersectionTargetOptions
) => {
    return useIntersectionTarget(
        PARENT_PAGE_INTERSECTION_OBSERVER_NAME,
        onIntersection,
        onIntersectionEnd,
        options
    );
};
